// test1756
(1756 && 0);
